import moment from "moment";

import type { DeadlineDto } from "@btnet/services-btnet/handlers/models/deadlineDto";
import type { DeadlineResponseDto } from "@btnet/services-btnet/handlers/models/deadlineResponseDto";
import type { Int32BTServiceGroupedListItem } from "@btnet/services-btnet/handlers/models/int32BTServiceGroupedListItem";

import {
    type ILinkToScheduleItem,
    type ILinkToScheduleItemFormValues,
    type LinkToScheduleItemEntity,
    mapScheduleItemDropdownOptions,
} from "commonComponents/entity/linkToScheduleItem/LinkToScheduleItem/LinkToScheduleItem.api.types";

export function mapDeadlineToScheduleLinkItem(data: DeadlineResponseDto): LinkToScheduleItemEntity {
    const scheduleLinkItem: ILinkToScheduleItem = {
        scheduleItemDropdownOptions: mapScheduleItemDropdownOptions(data.deadlineLinked),

        // Deadline is the prefilled date for due date (set in LinkToScheduleItemFormValues)
        deadline: data.dueDate ? moment(data.dueDate) : undefined,
        deadlineOffset: data.deadlineOffset ?? 0,
        dueTime: data.dueTime ? moment(data.dueTime) : undefined,
        userSelectedDefaultDeadline: data.userSelectedDefaultTime ?? false,
        isDeadlineLinked: data.isDeadlineLinked ?? false,
        deadLineIsAfterLinkedItem: data.deadlineBeforeOrAfter?.find((x) => x.selected)?.id === 1,

        readOnlyFields: {
            isDeadlineLinkedReadOnly: data.canEditSchedules ?? false,
            scheduleItemDropdownOptionsReadOnly: data.canEditSchedules ?? false,
            deadLineIsAfterLinkedItemReadOnly: data.canEditSchedules ?? false,
            deadlineOffsetReadOnly: data.canEditSchedules ?? false,
            deadlineReadOnly: data.canEditSchedules ?? false,
            dueTimeReadOnly: (data.dueTime && data.canEditSchedules) ?? false,
        },

        permissions: {
            canAddSchedules: data.canAddSchedules ?? false,
            canEditSchedules: data.canEditSchedules ?? false,
            canViewSchedules: data.canViewSchedules ?? false,
        },

        submittedDate: undefined,
        deadlineMinDate: undefined,
        paymentTerms: null,
    };

    return scheduleLinkItem;
}

export function mapScheduleLinkItemToDeadline(data: ILinkToScheduleItemFormValues): DeadlineDto {
    return {
        isDeadlineLinked: data.isDeadlineLinked,
        deadlineLinked: data.scheduleItemSelectedValue,
        deadlineOffset: data.deadlineOffset,
        dueDate: data.dueDate?.toDate(),
        dueTime: data.dueTime?.toDate(),
        deadlineBeforeOrAfter: data.deadlineIsAfterLinkedItem ? 1 : 2,
    };
}

export function mapAssignedToToSignees(data: Int32BTServiceGroupedListItem[]): number[] {
    return (data ?? [])
        .flatMap((group) => group?.options ?? [])
        .filter((opt) => !!opt && opt.selected)
        .map((opt) => opt?.id)
        .filter((id): id is number => typeof id === "number");
}
